import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["preserveAspectRatio", "viewBox"];
import React from 'react';

var Crown = function Crown(_ref) {
  var _ref$preserveAspectRa = _ref.preserveAspectRatio,
      preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'xMidYMid meet' : _ref$preserveAspectRa,
      _ref$viewBox = _ref.viewBox,
      viewBox = _ref$viewBox === void 0 ? '0 0 24 24' : _ref$viewBox,
      unhandledProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({}, unhandledProps, {
    preserveAspectRatio: preserveAspectRatio,
    viewBox: viewBox
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m20.464 10.408c-0.21181-0.13198-0.49423-0.15398-0.72957-0.065991l-4.3539 1.9577-2.73-6.0272c-0.11767-0.24197-0.35302-0.39595-0.63543-0.39595-0.28241-0.021997-0.54129 0.15398-0.65897 0.37395l-2.9654 6.0492-4.1185-1.9577c-0.23535-0.10999-0.51776-0.087988-0.72957 0.043994-0.21181 0.13198-0.32948 0.37395-0.28241 0.61592l1.1297 8.0509c0.047069 0.32996 0.35302 0.57192 0.70604 0.57192h13.815c0.35302 0 0.65897-0.24197 0.70604-0.57192l1.1297-8.0509c0.023535-0.21997-0.070604-0.46194-0.28241-0.59392zm-14.597 7.6543l-0.23438-1.7552h12.76l-0.22114 1.7552h-12.305zm14.883-7.1875c-0.69036 0-1.25-0.55964-1.25-1.25 0-0.69036 0.55964-1.25 1.25-1.25s1.25 0.55964 1.25 1.25c0 0.69036-0.55964 1.25-1.25 1.25zm-17.5 0c-0.69036 0-1.25-0.55964-1.25-1.25 0-0.69036 0.55964-1.25 1.25-1.25s1.25 0.55964 1.25 1.25c0 0.69036-0.55964 1.25-1.25 1.25zm8.75-4.375c-0.69036 0-1.25-0.55964-1.25-1.25s0.55964-1.25 1.25-1.25 1.25 0.55964 1.25 1.25-0.55964 1.25-1.25 1.25z"
  })));
};

Crown.displayName = 'Crown';
export default Crown;